import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { QualificationCriteria } from '@/services/types/firms-types';

import { AcceptedStatesConfig } from './AcceptedStatesConfig';
import { CaseTypeActionsConfig } from './CaseTypeActionsConfig';
import { DateOfLossConfig } from './DateOfLossConfig';

interface QualificationCriteriaSectionProps {
  criteria: QualificationCriteria | undefined;
  onChange: (criteria: QualificationCriteria) => void;
  isLoading?: boolean;
}

const DEFAULT_CRITERIA: QualificationCriteria = {
  date_of_loss_max_days: null,
  accepted_states: [],
  case_type_actions: {},
  default_case_type_action: 'accept',
};

export const QualificationCriteriaSection = ({
  criteria,
  onChange,
  isLoading,
}: QualificationCriteriaSectionProps) => {
  const current = criteria ?? DEFAULT_CRITERIA;

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="text-base">Qualification Criteria</CardTitle>
        <CardDescription className="text-xs">
          Quick rules for intake qualification decisions
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">
        {/* Date of Loss + Accepted States side by side */}
        <div className="flex max-w-2xl gap-6">
          <div className="flex-1">
            <DateOfLossConfig
              maxDays={current.date_of_loss_max_days}
              onChange={(maxDays) =>
                onChange({ ...current, date_of_loss_max_days: maxDays })
              }
              disabled={isLoading}
            />
          </div>

          <div className="w-px bg-border" />

          <div className="flex-1">
            <AcceptedStatesConfig
              selectedStates={current.accepted_states}
              onChange={(states) =>
                onChange({ ...current, accepted_states: states })
              }
              disabled={isLoading}
            />
          </div>
        </div>

        <div className="border-t pt-5">
          <CaseTypeActionsConfig
            actions={current.case_type_actions}
            defaultAction={current.default_case_type_action}
            onChange={(actions, defaultAction) =>
              onChange({
                ...current,
                case_type_actions: actions,
                default_case_type_action: defaultAction,
              })
            }
            disabled={isLoading}
          />
        </div>
      </CardContent>
    </Card>
  );
};
